import { PRODUCT_ALL_NAME } from 'src/const/title';
import { i18n } from '@flowus/common/i18n';

export interface ExportOption {
  type: 'png' | 'markdown' | 'csv';
  transparent: boolean;
  watermark: string;
  alreadySnapShot: boolean;
  isDarkMode: boolean;
}
export const WATERMARK = i18n.t('components.header.export.watermark', {
  productName: PRODUCT_ALL_NAME,
});
